import {
  Component,
  Input,
  ViewEncapsulation,
  OnChanges,
  ChangeDetectorRef,
  AfterViewInit,
  OnDestroy,
  EventEmitter,
  Output,
} from '@angular/core';

export interface CustomTableColumnDefinition {
  // tslint:disable: no-inferrable-types
  name: string;
  value: string;
  computedClass?: string;
  isAnchor?: boolean;
  isIcon?: boolean;
  style?: any;
  eventName?: any;
  title?: string;
  isCellClick?: boolean;
  iconName?: string;
  showToolTip?: boolean;
  iconColor?: string;
}

export class CustomTableConfig {
  public pageSize: number = 100;
  public pageNumber: number = 1;
  public totalCount: number = 0;
  public totalPages: number = 0;
}

export class CustomTableOptions {
  public records: any[];
  public columns: Array<CustomTableColumnDefinition>;
  public config: CustomTableConfig;
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'finra-table-internal',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class TableComponent implements OnChanges {
  @Input() options: CustomTableOptions;
  @Output() iconClickEvent = new EventEmitter();
  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnChanges() {
    this.preEvaluateCellValue();
    this.changeDetectorRef.markForCheck();
    this.changeDetectorRef.detectChanges();
  }

  preEvaluateCellValue() {
    const cellVaule = 'cellValue';
    this.options.records.forEach((row, rowIndex) => {
      this.options.columns.forEach((column, columnIndex) => {
        column[cellVaule + rowIndex + columnIndex] = this.getCellValue(row, column);
      });
    });
  }
  iconClick(row, column) {
    this.iconClickEvent.emit({
      row,
      column,
    });
    if (column.eventName) {
      column.eventName(row, column);
    }
  }
  getCellValue(row: any, column: CustomTableColumnDefinition): string {
    return column.value.split('.').reduce((prev: any, curr: string) => prev[curr], row);
  }

  cellClick(row, column) {
    if (column.eventName) {
      column.eventName(row, column);
    }
  }
}
